"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ClaimsList = void 0;
const filter_header_1 = require("client/components/filter-header");
const list_1 = require("client/components/material/list");
const list_item_1 = require("client/components/material/list/list-item");
const list_item_text_1 = require("client/components/material/list/list-item/list-item-text");
const store_1 = require("client/modules/orders/store");
const store_2 = require("client/modules/users/store");
const mobx_react_1 = require("mobx-react");
const React = require("react");
const react_1 = require("react");
const ReactTooltip = require("react-tooltip");
const order_1 = require("shared/order");
const permissions_1 = require("shared/permissions");
const capitalize_string_1 = require("shared/util/capitalize-string");
const moment = require("moment");
const mobx_1 = require("mobx");
require("./claims-list.less");
const text_field_small_1 = require("client/components/material/text-field/text-field-small");
const columns = [
    {
        center: false,
        id: "patient.lastName",
        numeric: false,
        label: "Patient"
    },
    {
        center: false,
        id: "site.displayName",
        numeric: false,
        label: "Pharmacy"
    },
    {
        center: false,
        id: "provider.lastName",
        numeric: false,
        label: "Provider"
    },
    {
        center: false,
        id: "order.createDate",
        numeric: false,
        label: "APPT DATE & Time"
    },
    {
        center: false,
        // id: "order.status",
        id: "statusPriority.priority",
        numeric: false,
        label: "Status"
    },
    {
        center: false,
        id: "",
        numeric: true,
        label: "Time Remaining"
    }
];
let ClaimsList = class ClaimsList extends react_1.Component {
    constructor() {
        super(...arguments);
        // For pagination // C-097 Claims
        this.page = 1;
        this.limit = 100; // C-110
        this.totalPages = 1;
        this.renderTableRow = (row, index) => {
            const now = moment();
            const appt = moment(row.createDate);
            const diff = appt.diff(now);
            const duration = moment.duration(appt.diff(now));
            const days = appt.diff(now, "days");
            let timeRemaining = "";
            if (diff > 0 && row.status === order_1.OrderStatus.Pending) {
                if (days > 0) {
                    timeRemaining = `${timeRemaining} ${days}d`;
                }
                timeRemaining = `${timeRemaining} ${duration
                    .hours()
                    .toString()
                    .padStart(2, "0")}:${duration
                    .minutes()
                    .toString()
                    .padStart(2, "0")}:${duration
                    .seconds()
                    .toString()
                    .padStart(2, "0")}`;
            }
            else {
                timeRemaining = "--:--:--";
            }
            const time = moment.tz(row.createDate, row.site.timezone);
            const auditUnsubmitted = row.auditStatus === order_1.AuditStatus.Unsubmitted;
            const auditPending = row.auditStatus === order_1.AuditStatus.Pending;
            const isError = row.status === order_1.OrderStatus.Error;
            const noneApprovedMsg = row.message.toLowerCase() === "no claims approved";
            const clinicErrorMessage = isError && noneApprovedMsg ? "None Approved" : "Out of Network";
            const isNotApproved = clinicErrorMessage === "None Approved";
            const isDev = store_2.usersStore.user.value.groupId === permissions_1.GROUPS.DEV;
            let statusText = "Claim Status"; // This should never show up.
            switch (row.status) {
                case order_1.OrderStatus.Ready:
                    statusText = auditUnsubmitted
                        ? "Ready for Provider Review"
                        : auditPending
                            ? "Approved to Dispense"
                            : "Ready To Dispense";
                    break;
                case order_1.OrderStatus.Pending:
                    statusText = "Pending Adjudication";
                    break;
                case order_1.OrderStatus.Intended:
                    statusText = "Intend to Dispense";
                    break;
                case order_1.OrderStatus.Progress:
                case order_1.OrderStatus.Executing:
                    statusText = "In Progress";
                    break;
                case order_1.OrderStatus.Reversing:
                    statusText = "Canceling";
                    break;
                case order_1.OrderStatus.Reversed:
                    statusText = "Canceled";
                    break;
                case order_1.OrderStatus.Error:
                    statusText = store_2.usersStore.permissions.ReadErrors
                        ? row.refill
                            ? "Refill Error"
                            : isNotApproved
                                ? "Ready to Cancel"
                                : "Error"
                        : clinicErrorMessage;
                    break;
                case order_1.OrderStatus.ReverseError:
                    statusText = isDev ? "Failed to Reverse" : "Pending Reversal";
                    break;
                case order_1.OrderStatus.Refill:
                    statusText = "Refill Due";
                    break;
                case order_1.OrderStatus.Refilled:
                    statusText = "Dispensed and Refilled";
                    break;
                default:
                    statusText = "Dispensed";
                    break;
            }
            if (statusText === "None Approved")
                row.status = order_1.OrderStatus.Reversed;
            const readFailures = store_2.usersStore.permissions.ReadFailures;
            const readErrors = store_2.usersStore.permissions.ReadErrors;
            const thisOrderIsAnError = row.status === order_1.OrderStatus.Error ||
                row.status === order_1.OrderStatus.ReverseError;
            if (thisOrderIsAnError) {
                /** If the user shouldn't see any red claims, or if they don't have permission
                 * to view failure-level claims and this claim was failure-level, don't render.
                 */
                if (!readErrors ||
                    (!readFailures &&
                        (statusText === "Error" ||
                            statusText === "Failed to Reverse" ||
                            statusText === "Pending Reversal"))) {
                    return null;
                }
            }
            const oneOrMoreClaimsFailedToReverse = "One or more claims failed to reverse";
            const oneOrMoreClaimsPendingReversal = "One or more claims pending reversal";
            const rowMessage = row.message === oneOrMoreClaimsFailedToReverse
                ? isDev
                    ? row.message
                    : oneOrMoreClaimsPendingReversal
                : row.message;
            const patientName = `${row.patient.lastName}, ${row.patient.firstName}`;
            const siteName = row.site.displayName || row.site.name || CONFIG.emptyText;
            const providerName = `${row.provider.lastName}, ${row.provider.firstName}`;
            return (React.createElement(list_item_1.MaterialListItem, { key: index, to: `/claims/${row.id}` },
                React.createElement(list_item_text_1.MaterialListItemText, { primary: capitalize_string_1.capitalizeString(patientName) }),
                React.createElement(list_item_text_1.MaterialListItemText, { primary: capitalize_string_1.capitalizeString(siteName) }),
                React.createElement(list_item_text_1.MaterialListItemText, { primary: capitalize_string_1.capitalizeString(providerName) }),
                React.createElement(list_item_text_1.MaterialListItemText, { primary: `${row.createDate ? time.format("MM/DD/YYYY hh:mm A") : ""} (${time.format("z")})` }),
                React.createElement(list_item_text_1.MaterialListItemText, { "data-tip": rowMessage, primary: React.createElement("div", { className: "orders-list__row" },
                        React.createElement("div", { className: `orders-list__status orders-list__status--${row.status}` }),
                        " ",
                        React.createElement("div", { className: "orders-list__status-text" }, statusText)) }),
                React.createElement(list_item_text_1.MaterialListItemText, { primary: (row.status !== order_1.OrderStatus.Done &&
                        row.status !== order_1.OrderStatus.Refilled &&
                        row.status !== order_1.OrderStatus.Reversed &&
                        timeRemaining) ||
                        "" })));
        };
        this.renderTable = () => {
            let { orders: { value: orders = [] } } = store_1.ordersStore;
            if (!store_2.usersStore.permissions.ReadErrors) {
                orders = orders.filter(order => !(order.status === order_1.OrderStatus.Error ||
                    order.status === order_1.OrderStatus.ReverseError));
            }
            if (store_2.usersStore.userProvider &&
                store_2.usersStore.userProvider.value &&
                store_2.usersStore.userProvider.value.userId === store_2.usersStore.user.value.id &&
                store_2.usersStore.user.value.siteUser &&
                !store_2.usersStore.user.value.siteAdmin) {
                orders = orders.filter(order => order.provider.userId === store_2.usersStore.user.value.id);
            }
            // C-045.1
            const { isClaim } = store_1.ordersStore;
            const path = window.location.pathname; // B-104
            return (React.createElement("div", { className: "orders__table" },
                React.createElement(list_1.MaterialList, { columns: columns, onRequestSort: this.props.onRequestSort, order: this.props.order, orderBy: this.props.orderBy, 
                    // rows={orders}
                    rows: isClaim ? store_1.ordersStore.claimOrders : orders, renderRow: this.renderTableRow, resizableheader: true, customClass: "custom-material-list__order-list", decoration: { top: path === "/claims" ? 233 : 0, zIndex: 1, type: "sticky" } })));
        };
    }
    componentDidUpdate() {
        ReactTooltip.rebuild();
    }
    componentDidMount() {
        console.info("claimslist triggered");
    }
    render() {
        var _a, _b, _c;
        const path = window.location.pathname; // B-104
        // C-045.1
        let { orders: { value: orders = [] }, } = store_1.ordersStore;
        // B-104
        const freezHeader = {
            position: "sticky",
            marginTop: path === "/claims" ? 0 : 'unset',
            top: 110,
            zIndex: 200
        };
        return (React.createElement("div", { className: "orders__form paymentProcess" },
            React.createElement(filter_header_1.FilterHeader, { decoration: path === "/claims" && freezHeader, title: (_a = this.props.filterTitle) !== null && _a !== void 0 ? _a : store_1.ordersStore.paymentTitle, label: (_b = this.props.filterLabel) !== null && _b !== void 0 ? _b : "Search", switchChecked: this.props.switchChecked, switchChecked2: this.props.switchChecked2, switchLabel: (_c = this.props.switchLabel) !== null && _c !== void 0 ? _c : "Show Completed Claims", switchLabel2: this.props.switchLabel2, withDatePicker: true, withSwitch: true, withSwitch2: true, callBack: this.props.onFilterChange, filterDate: this.props.filterDate, filterText: this.props.filterText, handleToggle: this.props.toggleShowCompleted, handleToggle2: this.props.toggleShowPaidCash }),
            this.renderTable(),
            React.createElement("div", { className: "pagination-container-header" },
                React.createElement("button", { className: "btn--pagination btn--pagination--right", onClick: () => this.props.clickPrevious() }, "Previous"),
                React.createElement("div", { className: "pagination-container" },
                    React.createElement("p", null, "Page"),
                    React.createElement("div", { style: { display: 'contents' } },
                        React.createElement("div", { className: "cstmPaginationInput-Wrapper" },
                            React.createElement(text_field_small_1.MaterialTextFieldSmall, { className: "pagination-input", autoFocus: true, type: "text", onChange: (e) => {
                                    const value = Number(e.target.value);
                                    if (value <= store_1.ordersStore.totalProviderPage) {
                                        store_1.ordersStore.currentPage = value;
                                    }
                                    else {
                                        store_1.ordersStore.currentPage = store_1.ordersStore.totalProviderPage;
                                    }
                                }, onKeyDown: () => { }, onKeyDownEnterPress: () => {
                                    this.props.handleKeyDown(store_1.ordersStore.currentPage);
                                }, value: store_1.ordersStore.currentPage || "" })),
                        React.createElement("div", null, "of"),
                        React.createElement("div", null, store_1.ordersStore.totalProviderPage)),
                    React.createElement("select", { className: "pagination-input", onChange: (value) => this.props.clickSelectDropdown(value.target.value), defaultValue: this.limit },
                        React.createElement("option", { value: "5" }, "5 rows"),
                        React.createElement("option", { value: "10" }, "10 rows"),
                        React.createElement("option", { value: "25" }, "25 rows"),
                        React.createElement("option", { value: "50" }, "50 rows"),
                        React.createElement("option", { value: "100" }, "100 rows"))),
                React.createElement("button", { className: "btn--pagination btn--pagination--left", onClick: () => this.props.clickNext() }, "Next")),
            React.createElement(ReactTooltip, { effect: "solid", place: "left" })));
    }
};
__decorate([
    mobx_1.observable
], ClaimsList.prototype, "page", void 0);
__decorate([
    mobx_1.observable
], ClaimsList.prototype, "limit", void 0);
__decorate([
    mobx_1.observable
], ClaimsList.prototype, "totalPages", void 0);
ClaimsList = __decorate([
    mobx_react_1.observer
], ClaimsList);
exports.ClaimsList = ClaimsList;



//////////////////
// WEBPACK FOOTER
// ./src/client/modules/orders/modules/orders-list/components/claims-list/claims-list.tsx
// module id = 3764
// module chunks = 0